import Paper from '@mui/material/Paper';
import React from 'react';
import { connect } from 'react-redux';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import RMAFeeTable from '@sophocles/views/admin/management/rmaFee/RMAFeeTable';

class RMAFeePage extends React.Component {
  render() {
    const pageTitle = 'RMA Fees';

    return (
      <AppNav {...this.props} page="admin_home" notFullHeight={true}>
        <div className="container-fluid" style={{ top: '64px', margin: '0 var(--page-px)' }}>
          <TitleBar title={pageTitle} showBackButton />
          <div className="row" style={{ height: 'calc(100% - 64px)' }}>
            <Paper
              sx={{
                width: '100%',
                height: '100%',
                bgcolor: 'background.paper',
                mb: 'var(--space-4)',
              }}
            >
              <RMAFeeTable />
            </Paper>
          </div>
        </div>
      </AppNav>
    );
  }
}

export default connect()(RMAFeePage);
